import { useState, useRef, useEffect } from 'react';
import { Box, Button, FormControl, InputLabel, MenuItem, Paper, Popover, Select } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

const PopOverForm = ({ 
  buttonText = 'Select Date', 
  onSubmit,
  defaultDate = null,
  openExternally = false,
  onCloseExternal, 
  hideButton = false,
  selectOptions = [],
  selectLabel = 'Choose One',
  selectValue = '',
  onSelectChange = () => {},
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [tempDate, setTempDate] = useState(defaultDate ? dayjs(defaultDate) : null);
  const [selected, setSelected] = useState(selectValue);

  const buttonRef = useRef();

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleDateChange = (newValue) => {
    setTempDate(newValue);
  };

  useEffect(() => {
    if (openExternally && buttonRef.current) {
      setAnchorEl(buttonRef.current);
    }
  }, [openExternally]);

  const handleClose = () => {
    setAnchorEl(null);
    onCloseExternal?.(); 
  }

  const handleSubmit = () => {
    if (tempDate) {
      onSubmit(tempDate, selected);
    }
    setAnchorEl(null);
    onCloseExternal?.();
  };

  const handleSelect = (e) => {
    setSelected(e.target.value);
    onSelectChange(e.target.value);
  };

  const open = Boolean(anchorEl);

  return (
    <>
    {!hideButton && (      
      <Button size="small" sx={{ p: 0 }} onClick={handleClick}>
        {buttonText}
      </Button>
    )}
    {hideButton && <span ref={buttonRef} />}

      <Popover 
        open={open} 
        anchorEl={anchorEl} 
        onClose={handleClose}
        anchorOrigin={{
            vertical: 'bottom', 
            horizontal: 'left' 
        }} 
       >
            <Paper sx={{ p: 2, minWidth: 300 }}>
              <Box sx={{ width: '100%' }}>
    
                {selectOptions.length > 0 && (
                  <FormControl fullWidth variant="outlined" sx={{ mb: 1 }}>
                    <InputLabel id="dtp-select-label">{selectLabel}</InputLabel>
                    <Select
                      labelId="dtp-select-label"
                      value={selected}
                      onChange={handleSelect}
                      label={selectLabel}
                      
                    >
                      {selectOptions.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                <LocalizationProvider dateAdapter={AdapterDayjs} >
                    <DateTimePicker
                        value={tempDate || null}
                        onChange={handleDateChange}
                        disablePast
                        minutesStep={5}
                        sx={{ width: '100%' }}
                        label="Select Date and Time"
                    />
                </LocalizationProvider>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                  <Button onClick={handleSubmit} variant="contained" size="small">
                    Submit
                  </Button>
                </Box>
              </Box>
            </Paper>
      </Popover>
    </>
  );
};

export default PopOverForm;
